<div class="ticket-summary-list"
     fxLayout="column"
     fxLayoutGap="20px">

    <ng-container *ngFor="let eventTicketItems of eventShoppingItemsMap |keyvalue; last as isLast ">

        <btx-ticket-summary-item [eventTickets]="eventTicketItems.value"
                                 [showLiveEventContainer]="showLiveEvent"
                                 [isLast]="isLast"
                                 [digitalTicketLink]="shoppingCart.digitalTicketLink"
                                 [invoiceLink]="shoppingCart.eticketLink"
                                 [isHomePrint]="isHomePrint()"
                                 [liveEventTokens]="shoppingCart.liveEventTokens"
                                 [liveEvent]="shoppingCart.shoppingItems.liveEvent"
                                 [liveEventDistributionLink]="shoppingCart.liveEventDistributionLink"
                                 [eventUpsells]="eventShoppingUpsellMap.get(eventTicketItems.key)">
        </btx-ticket-summary-item>
    </ng-container>

</div>
